<template>
  <v-row align="center">
    <v-col cols="auto" class="pr-2 pb-0">
      <!-- TODO - Do not use v-model here. This causes problems when there's an error with API request. -->
      <v-checkbox
        v-model="task.completed"
        hide-details="true"
        @change="
          updateTaskCompleted({ id: task.id, completed: task.completed })
        "
        class="pt-0 mt-0"
      >
      </v-checkbox>
    </v-col>

    <v-col class="pl-0 pb-0">
      <v-card outlined>
        <v-card-text class="py-3">
          <v-row align="center">
            <v-col cols="3" align="left">
              <router-link :to="{ name: 'task', params: { task_id: task.id } }">
                <span
                  :class="{ 'text-decoration-line-through': task.completed }"
                  >{{ task.title }}</span
                >
              </router-link>
            </v-col>

            <v-col cols="2" align="center">
              <router-link
                :to="{
                  name: 'project',
                  params: { project_id: task.task_list.project.id }
                }"
              >
                {{ task.task_list.project.name }}
              </router-link>
            </v-col>

            <v-col cols="2" align="center">
              <router-link
                :to="{
                  name: 'tasklist',
                  params: { task_list_id: task.task_list.id }
                }"
              >
                {{ task.task_list.title }}
              </router-link>
            </v-col>

            <v-col cols="2" align="center">
              {{ task.assigned_to ? task.assigned_to.name : 'Unassigned' }}
            </v-col>

            <v-col cols="2" align="center">
              {{ task.updated_at }}
            </v-col>

            <v-col cols="1" align="right">
              <v-btn icon @click="confirmDelete">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { alertConfirm } from '@/utilities/sweetalert'

export default {
  name: 'TasksTableItem',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('tasks', ['updateTaskCompleted', 'deleteTask']),
    confirmDelete() {
      alertConfirm(
        {
          title: `Are you sure you want to delete ${this.task.name} task?`
        },
        () => this.deleteTask(this.task.id)
      )
    }
  }
}
</script>
